import { Pipe, PipeTransform } from '@angular/core';

import { individualName, individualNameSuffixValue } from '@app/helpers/people.helpers';

import { Individual } from '@app/models/individual.model';

@Pipe({
    name: 'fullnamesummary',
    standalone: false
})
export class FullNameSummaryPipe implements PipeTransform {
  transform(individual: Individual, alternative = 'this person'): string {
    const name = individualName(alternative, individual);

    if(JSON.parse(sessionStorage.getItem("embsDriverFlow")) && individual ) {
      const genderCode = individual.gender?.code ? (individual.age !== null && individual.age !== undefined ? ' ' : ', ') + individual.gender.code : '';
      const individualAge = individual.age !== null && individual.age !== undefined ? ', ' + individual.age : '';
      if(individual.name && individual.name.suffix) {
        return name + " " + individualNameSuffixValue(alternative,individual.name) + individualAge + genderCode;
      } else {
        return name + individualAge + genderCode;
      }
    }

    if(individual && individual.name && individual.name.suffix){
      return name + " " + individualNameSuffixValue(alternative,individual.name)+ ", " + individual.age + " " + individual.gender.code;
    }else{
      return name + ", " + individual.age + " " + individual.gender.code;
    }
  }
}

